import React from 'react';

const EyeOpen = ({ className = "w-5 h-5" }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
  </svg>
);


// Alternative version with fixed aspect ratio (better for typical usage)
const EyeClosed = ({ 
  size = 24,
  color = "currentColor",
  strokeWidth = 1.5,
  className = "",
  ...props 
}) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.1084 7.89258L7.89172 12.1092C7.35006 11.5676 7.01672 10.8259 7.01672 10.0009C7.01672 8.35091 8.35006 7.01758 10.0001 7.01758C10.8251 7.01758 11.5667 7.35091 12.1084 7.89258Z" stroke="#7F7F7F" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M14.85 4.80742C13.3917 3.70742 11.725 3.10742 9.99999 3.10742C7.05833 3.10742 4.31666 4.84076 2.40833 7.84075C1.65833 9.01575 1.65833 10.9908 2.40833 12.1658C3.06666 13.1991 3.83333 14.0908 4.66666 14.8074" stroke="#7F7F7F" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M7.01672 16.2741C7.96672 16.6741 8.97506 16.8908 10.0001 16.8908C12.9417 16.8908 15.6834 15.1574 17.5917 12.1574C18.3417 10.9824 18.3417 9.00742 17.5917 7.83242C17.3167 7.39909 17.0167 6.99076 16.7084 6.60742" stroke="#7F7F7F" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12.925 10.584C12.7083 11.759 11.75 12.7173 10.575 12.934" stroke="#7F7F7F" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M7.89163 12.1074L1.66663 18.3324" stroke="#7F7F7F" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M18.3333 1.66602L12.1083 7.89102" stroke="#7F7F7F" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

  );
};



export { EyeOpen, EyeClosed };